import React, { useMemo } from 'react';
import classNames from 'classnames';
import _ from 'lodash';

import css from './style.module.scss';
import Conditional from '../../../common/conditional';

import { getValueRange, renderCell, renderStyle } from '../../../../utils/utilities';
import { getConcreteInspectionItemColumns } from '../../../../utils/data';
import { Column, ConcreteHammerReportItem } from '../../../../utils/models';

export interface DataRange {
	startRange: number;
	endRange: number;
	range: number[]
}

interface Props {
    dataRange: DataRange;
    data: ConcreteHammerReportItem[];
    showTotal: boolean;
}

const ConcreteHammerData: React.FC<Props> = ({ data, dataRange, showTotal }) => {
    const totalConcreteReadings = useMemo(() => {
        const valueRange = getValueRange(dataRange.startRange, dataRange.endRange);
        const totalReadings = data.reduce((a, c) => {
            const values = valueRange.map((value) => _.get(c, value));
            return a + values.length;
        }, 0);

        return totalReadings;
    }, [data, dataRange]);

    return ( 
        <>
            <div className={classNames([css.concreteHammerReport, "table-responsive p-2"])}>
                <table className={css['pdf-table']}>
                    <thead>
                        <tr>
                            <th rowSpan={2}>Test Location</th>                            
                            <th colSpan={dataRange.range.length}>Findings</th>                            
                            <th rowSpan={2}>Average</th>                            
                            <th rowSpan={2}>Strength (Kg/Cm2)</th>                            
                            <th rowSpan={2}>Result</th>                            
                        </tr>
                        <tr>
                            {dataRange.range.map((label) => (
                                <th key={label}>{label}</th>                            
                            ))}                           
                        </tr>
                    </thead>

                    <tbody>
                        <Conditional isVisible={data.length > 0}>
                            {data.map((item, index: number) => (
                                <tr key={index}>
                                    {getConcreteInspectionItemColumns(dataRange.startRange, dataRange.endRange).map((column: Column) => (
                                        <td key={column.path} style={renderStyle(item, column)}>
                                            {renderCell(item, column, index)}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </Conditional>
                    </tbody>
                </table>
            </div>

            <Conditional isVisible={showTotal}>
                <div className="p-2">
                    <div className={css.concreteHammerReportHeader}>
                        TOTAL NUMBER OF CONCRETE TEST READINGS: {totalConcreteReadings}
                    </div>
                </div>
            </Conditional>
        </>
     );
};
 
export default ConcreteHammerData;